import { render } from "./booking-detail-modal.template.html?vue&type=template&id=09bde771&scoped=true"
import script from "./BookingDetailModal.vue?vue&type=script&lang=ts"
export * from "./BookingDetailModal.vue?vue&type=script&lang=ts"

import "./BookingDetailModal.vue?vue&type=style&index=0&id=09bde771&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-09bde771"

export default script